module.exports = __webpack_public_path__ + "static/media/facebook.a67b69d2.bmp";